import {Injectable, NgZone} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {DoodOrderModel} from '@store/order/order.model';
import {DOOD_API} from '@config/ws.config';

export interface NeptingPreauthResponse {
  success: boolean;
  message?: string;
  authorization_id?: string;
  holder_receipt?: string[];
  token?: string;
}

export interface NeptingCaptureResponse {
  success: boolean;
  message?: string;
  holder_receipt?: string[];
  capture_planned?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class NeptingTerminalApiService {
  private readonly baseUrl = 'http://127.0.0.1:5000';

  private statusSubject = new Subject<string>();
  public status$: Observable<string> = this.statusSubject.asObservable();

  private eventSource: EventSource | null = null;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly zone: NgZone,
  ) {
  }

  abortTransaction$(): Observable<{ success: boolean; message: string }> {
    return this.httpClient.post<{ success: boolean; message: string }>(
      `${this.baseUrl}/abort`,
      {}
    );
  }

  transaction$(montant: number): Observable<NeptingPreauthResponse> {
    return this.httpClient.post<NeptingPreauthResponse>(`${this.baseUrl}/transaction`, {montant});
  }

  preAuthorize$(montant: number): Observable<NeptingPreauthResponse> {
    return this.httpClient.post<NeptingPreauthResponse>(`${this.baseUrl}/preauth`, {montant});
  }

  capture$(authorizationId: string, montant: number, token: string): Observable<NeptingCaptureResponse> {
    return this.httpClient.post<NeptingCaptureResponse>(`${this.baseUrl}/capture`, {
      authorization_id: authorizationId,
      montant,
      token
    });
  }

  merchantContract$(): Observable<{ merchant_contract: string }> {
    return this.httpClient.get<{ merchant_contract: string }>(`${this.baseUrl}/merchant-contract`);
  }

  changeOrderStatusToPayment$(orderId: string, paymentRef: string): Observable<DoodOrderModel> {
    return this.httpClient.post<DoodOrderModel>(`${DOOD_API}/payment-services/nepting/payment`, {
      order_id: orderId,
      terminal_payment_ref: paymentRef,
    });
  }

  startDisplayStream(): void {
    // Toujours fermer l'ancienne connexion proprement
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }

    // Création du nouveau EventSource (sans setTimeout)
    this.eventSource = new EventSource(`${this.baseUrl}/message`);

    this.eventSource.onmessage = (event: MessageEvent) => {
      const message = event.data?.trim();
      if (message && !message.startsWith(':')) {
        this.zone.run(() => {
          this.statusSubject.next(message);
        });
      }
    };
  }

  stopDisplayStream(): void {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
  }

}
